export const FORBIDDEN = "/s/forbidden";
export const PROFILE = "/s/profile";
export const HELP_CENTER_UNAVAILABLE = "/s/help-center-unavailable";
export const HELP_CENTER_LOGIN = "/help-center-login";
